package com.milta.feature.ocrscan.data.repository

import com.milta.core.image.normalizePhotoOrientation
import com.milta.feature.ocrscan.data.remote.OcrScanApi
import com.milta.feature.ocrscan.data.remote.dto.toDomain
import com.milta.feature.ocrscan.domain.entity.OcrScanResult
import com.milta.feature.ocrscan.domain.repository.OcrScanRepository
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

class OcrScanRepositoryImpl(private val api: OcrScanApi) : OcrScanRepository {
    override suspend fun scanPhoto(fileBytes: ByteArray, fileName: String): OcrScanResult {
        // Photo redressée avant envoi (appareil photo comme galerie, premier envoi comme nouvel
        // essai) : une liste photographiée téléphone tourné arrive sinon couchée au modèle.
        val upright = withContext(Dispatchers.Default) { normalizePhotoOrientation(fileBytes) }
        return api.scanPhoto(upright, fileName).toDomain()
    }
}
